import { makeStyles } from '@material-ui/core/styles'

export const viewCodeStyles = makeStyles((theme) => ({
  RequestDataWrapper: {
    width: '100%',
    padding: theme.spacing(3, 2, 0),
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    minHeight: 300,
    '& .MuiAccordion-root': {
      backgroundColor: theme.palette.colors.body
    },
    '&.reuse': {
      backgroundColor: theme.palette.colors.body,
      paddingBottom: theme.spacing(3),
      minHeight: 50,
      '& .MuiAccordion-root': {
        backgroundColor: theme.palette.common.white
      }
    }
  },
  RequestHeading: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: theme.spacing(0),
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: theme.typography.pxToRem(30)
    }
  },
  RequestInfoWrapper: {
    width: '100%',
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
    marginBottom: theme.spacing(2),
    '&.center': {
      justifyContent: 'center'
    }
  },
  infoItemWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    // fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      '&:nth-of-type(2n+1)': {
        backgroundColor: theme.palette.colors.table
      }
    },
    '&.no-height': {
      padding: theme.spacing(0),
      height: 0
    },
    '&:not(.attachment-item-wrapper)': {
      [theme.breakpoints.only('sm')]: {
        '&:nth-of-type(4n+1),&:nth-of-type(4n+2)': {
          backgroundColor: theme.palette.colors.table
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      '&:nth-of-type(4n+1),&:nth-of-type(4n+2)': {
        backgroundColor: theme.palette.colors.table
      }
    }

  },
  infoItemLabel: {
    fontWeight: theme.typography.fontWeightBold,
    paddingRight: theme.spacing(2)
  },
  category: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.25),
    wordBreak: 'break-word',
    '& svg': {
      marginRight: theme.spacing(0.25),
      fontSize: theme.typography.pxToRem(20)
    },
    '&.level2': {
      marginLeft: theme.spacing(0.25)
    },
    '&.level3': {
      marginLeft: theme.spacing(2.25)
    },
    '&.level4': {
      marginLeft: theme.spacing(4.25)
    }
  },
  attribute: {
    textTransform: 'capitalize',
    '& span': {
      marginRight: theme.spacing(0.25)
    }
  },
  RequestDataContainer:{
    width: '100%',
  }
}))
